import 'css-chunksrc/client/common/richTextInput/toolbarPopover/styles.scss';export default {
  "popover": "_popover_14unz_1",
  "title": "_title_14unz_17",
  "row": "_row_14unz_24",
  "input": "_input_14unz_30",
  "confirm": "_confirm_14unz_46",
  "cancel": "_cancel_14unz_61",
  "remove": "_remove_14unz_75"
};